import type { ToastMessage } from 'primereact/toast';
import type { ReactNode } from 'react';
import { Icon, type IconTypes } from '../Icon/Icon';

const toastTitle = {
    info: 'Info',
    success: 'Success',
    warn: 'Warning',
    error: 'Error',
    secondary: 'Info',
    contrast: 'Info',
} as const;

const toastIcon: Record<string, IconTypes> = {
    info: 'info_i',
    success: 'check_circle',
    warn: 'warning',
    error: 'error',
    secondary: 'info_i',
    contrast: 'info_i',
} as const;

export function ToastContent({
    message,
}: {
    message: ToastMessage;
}): ReactNode {
    const severity = message.severity ?? 'info';
    return (
        <div
            className="flex flex-row gap-3 align-items-center"
            data-testid={`toast-${severity}`}
        >
            <Icon
                fontSize="normal"
                className="p-toast-message-icon"
                name={toastIcon[severity]}
            />
            <div className="flex flex-column gap-1 align-items-start">
                <strong className="p-toast-message-title">
                    {toastTitle[severity]}
                </strong>
                <div>{message.detail}</div>
            </div>
        </div>
    );
}
